<template>
  <div class="over-view-main-top">
    <div class="over-view-main-top-line" v-for="line in topData">
      <div :class="item.name ? 'over-view-main-top-item' : 'over-view-main-top-item-no-data'" v-for="item in line" :style="{background: item.background}">
        <div class="over-view-main-top-item-info" :style="{color: item.color}">
          <div class="over-view-main-top-item-info-name">{{item.name}}</div>
          <div class="over-view-main-top-item-info-num" >{{item.value}}<span class="over-view-main-top-item-info-unit" v-if="item.unit">({{item.unit}})</span></div>
        </div>
        <img :src="item.icon" alt="" class="over-view-main-top-item-img">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverViewTopLine",
  props: {
    topData: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style scoped lang="less">
.over-view-main-top {
  width: 100%;
  .over-view-main-top-line {
    width: 100%;
    margin-bottom: 0.12rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .over-view-main-top-item-no-data {
      //flex: 1;
      width: 1.98rem;
      padding: 0.16rem;
      height: 0.69rem;
      background-color: #fff;
      border-radius: 0.06rem;
    }
    .over-view-main-top-item-no-data:last-child {
      margin: 10px 0;
    }
    .over-view-main-top-item {
      //flex: 1;
      width: 1.98rem;
      padding: 0.16rem;
      height: 0.69rem;
      background-color: #fff;
      //margin: 10px 18px 10px 0;
      border-radius: 0.06rem;
      //box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .over-view-main-top-item-img {
        width: 0.37rem;
        height: 0.37rem;
      }
      .el-icon-damai-xitongguanli-zhuceqiye {
        font-size: 48px;
      }
      .over-view-main-top-item-info {
        flex: 1;
        text-align: left;
        .over-view-main-top-item-info-name {
          //height: 22px;
          font-size: 0.1rem;
          margin-bottom: 0.08rem;
          font-family: Source Han Sans SC;
          font-weight: 400;
          //line-height: 22px;
          text-align: left;
        }
        .over-view-main-top-item-info-num {
          word-wrap:break-word;
          //height: 43px;
          text-align: left;
          font-size: 0.18rem;
          font-weight: 500;
          //font-family: DINPro;
          //line-height: 43px;
          opacity: 1;
          .over-view-main-top-item-info-unit {
            font-size: 0.08rem;
          }
        }
      }
    }

    //.over-view-main-top-item:last-child {
    //  margin: 10px 0;
    //}
  }
}
.over-view-main-top .over-view-main-top-line:nth-child(2) .over-view-main-top-item .over-view-main-top-item-info .over-view-main-top-item-info-num {
  font-size: 0.17rem;
}
</style>



// WEBPACK FOOTER //
// src/components/OverView/newOverViewTopLine.vue